import { connect } from 'react-redux';

import actionTypes from '../actionTypes';
import Routes from '../Routes';
import { SESSION_ENV_KEY } from '../utils/config';
import {
	getParsedLocalStorageData,
	setStringifiedLocalStorageData,
} from '../utils/functions';
import { createNamespacer } from '../utils/reducers';

const sessionNamespacer = createNamespacer('SESSION');

const mapStateToProps = (state) => ({
	session: state.session,
});

const mapDispatchToProps = (dispatch) => ({
	onSetSession: (value) => {
		const session = { ...value };
		const { isLoggedIn } = session;
		const localStorageData = getParsedLocalStorageData(SESSION_ENV_KEY);

		if (isLoggedIn) {
			if (
				!localStorageData?.token &&
				!localStorageData?.userId &&
				!localStorageData?.roleName
			) {
				delete session.isLoggedIn;
				setStringifiedLocalStorageData(SESSION_ENV_KEY, session);
			} else if (!localStorageData?.uuid || !localStorageData.intercomHash) {
				setStringifiedLocalStorageData(SESSION_ENV_KEY, session);
			}
		}

		dispatch({
			type: sessionNamespacer(actionTypes.session.SET_SESSION),
			payload: {
				isLoggedIn,
				...session,
			},
		});
	},
});

export default connect(mapStateToProps, mapDispatchToProps)(Routes);
